export default "__VITE_ASSET__CZb3scdy__"